// src/myPlans/PlanConfirmation.js
// Confirms a change to an existing Pro subscription (minutes and/or billing period).

import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import './planConfirmation.css';

export default function PlanConfirmation({ onClose, total, paymentInterval, paymentMethod, selectedQuantity }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);
    try {
      const updateSub = httpsCallable(getFunctions(), 'updateStripeSubscription');
      await updateSub({ selectedQuantity, planType: 'pro', paymentInterval });
      onClose();
    } catch {
      setError('Something went wrong. Your plan was not changed — please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="plan-confirmation-overlay">
      <div className="plan-confirmation-modal" role="dialog" aria-modal="true" aria-labelledby="plan-confirmation-title">
        <div className="plan-confirmation-header">
          <h2 id="plan-confirmation-title">Confirm changes</h2>
          <button className="plan-confirmation-close" aria-label="Close" onClick={onClose} disabled={loading}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className="plan-confirmation-body">
          <div className="plan-confirmation-row">
            <div>
              <div className="plan-confirmation-title">Bumpups Pro · {(selectedQuantity * 1000).toLocaleString()} minutes</div>
              <div className="plan-confirmation-subtitle">
                {paymentInterval === 'yearly' ? 'Billed annually' : 'Billed monthly'}, starting today
              </div>
            </div>
            <div className="plan-confirmation-value">${total.toFixed(2)}</div>
          </div>

          <hr />

          <div className="plan-confirmation-row">
            <div className="plan-confirmation-title">Payment method</div>
            <div className="plan-confirmation-value">{paymentMethod || '--'}</div>
          </div>

          {error && <div className="plan-confirmation-error">{error}</div>}
        </div>

        <div className="plan-confirmation-footer">
          <button className="plan-cancel-button" onClick={onClose} disabled={loading}>Cancel</button>
          <button className="plan-confirm-button" onClick={handleConfirm} disabled={loading}>
            {loading ? 'Processing…' : 'Pay now'}
          </button>
        </div>
      </div>
    </div>
  );
}
